// seconds * minutes * hours * days
export const COOKIE_EXPIRATION_TIME = 60 * 60 * 24 // 1 day
export const TOKEN_COOKIE = 'coop.token'
export const REFRESH_TOKEN_COOKIE = 'coop.refreshToken'
export const BADGES_STORAGE_KEY = 'coop.badges'
